import React from "react";
import RenderTranslatedText from "../../../components/RenderTranslatedText";

const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.otanative.ota";
const APP_STORE_URL = "https://apps.apple.com/in/app/ota-life/id6743555476";

function detectOS() {
  const ua = navigator.userAgent || navigator.vendor || window.opera || "";
  if (/android/i.test(ua)) return "android";
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return "ios";
  return "other";
}

export default function AppDownloadNudge({ compact = false }) {
  const os = detectOS();
  const showAndroid = os === "android" || os === "other";
  const showIOS = os === "ios" || os === "other";

  return (
    <div
      className={`w-full rounded-xl gradient border border-[#e9e6fb] flex items-center justify-between gap-3 ${
        compact ? "p-3" : "p-4"
      }`}
    >
      <div className="min-w-0">
        <p className="text-sm font-semibold otaDark truncate">
          <RenderTranslatedText i8nKey="shop_download_app_title" />
        </p>
        <p className="text-xs otaLight">
          <RenderTranslatedText i8nKey="shop_download_app_subtitle" />
        </p>
      </div>
      <div className="flex gap-2 shrink-0">
        {showAndroid && (
          <a
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="otaGradientButton text-white text-xs font-semibold px-3 py-2 rounded-lg whitespace-nowrap"
          >
            Android
          </a>
        )}
        {showIOS && (
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="otaGradientOutlineButton text-xs font-semibold px-3 py-2 whitespace-nowrap"
          >
            iOS
          </a>
        )}
      </div>
    </div>
  );
}
